import {
  MEDIA_BUYING_AGENT_ID,
  TRACIFY_AGENT_ID,
  type ChatAgentId,
} from "@tracify/shared";

export const CHAT_AGENT_QUERY_PARAM = "agent";
export const chatAgentValues = ["analytics", "media-buying"] as const;

export type ChatAgent = (typeof chatAgentValues)[number];
export type ChatAgentAvailability = {
  mediaBuyingAgentEnabled: boolean;
};

export const DEFAULT_CHAT_AGENT: ChatAgent = "analytics";
const DEFAULT_CHAT_AGENT_AVAILABILITY: ChatAgentAvailability = {
  mediaBuyingAgentEnabled: false,
};

export const chatAgentOptions: { value: ChatAgent; label: string }[] = [
  {
    value: "analytics",
    label: "Analytics Agent",
  },
  {
    value: "media-buying",
    label: "Media Buying Agent",
  },
];

function resolveChatAgentAvailability(
  availability?: Partial<ChatAgentAvailability>
): ChatAgentAvailability {
  return {
    ...DEFAULT_CHAT_AGENT_AVAILABILITY,
    ...availability,
  };
}

export function canUseChatAgent(
  agent: ChatAgent,
  availability?: Partial<ChatAgentAvailability>
): boolean {
  if (agent === "media-buying") {
    return resolveChatAgentAvailability(availability).mediaBuyingAgentEnabled;
  }

  return true;
}

export function getAvailableChatAgentOptions(
  availability?: Partial<ChatAgentAvailability>
): typeof chatAgentOptions {
  return chatAgentOptions.filter((agentOption) =>
    canUseChatAgent(agentOption.value, availability)
  );
}

export function parseChatAgent(
  value: unknown,
  availability?: Partial<ChatAgentAvailability>
): ChatAgent {
  const agent = value === "media-buying" ? value : DEFAULT_CHAT_AGENT;
  return canUseChatAgent(agent, availability) ? agent : DEFAULT_CHAT_AGENT;
}

export function getChatAgentId(agent: ChatAgent): ChatAgentId {
  return agent === "media-buying" ? MEDIA_BUYING_AGENT_ID : TRACIFY_AGENT_ID;
}
